import * as PropTypes from 'prop-types';
import React from 'react';
import {
  Link,
  Breadcrumbs as MUIBreadcrumbs,
  Typography,
  styled,
} from '@mui/material';
import {Link as RouterLink} from 'react-router-dom';

const Crumb = ({children, url}) =>
  url ? (
    <Link
      color="inherit"
      component={RouterLink}
      data-testid="breadcrumb"
      to={url}
      underline="hover"
      variant="body2"
    >
      {children}
    </Link>
  ) : (
    <Typography
      color="textPrimary"
      data-testid="current-breadcrumb"
      variant="body2"
      sx={{wordBreak: 'break-word'}}
    >
      {children}
    </Typography>
  );

Crumb.propTypes = {
  url: PropTypes.string,
  children: PropTypes.node.isRequired,
};

const StyledBreadcrumbs = styled(MUIBreadcrumbs)(({theme}) => ({
  marginBottom: theme.spacing(2),
  '& .MuiBreadcrumbs-ol': {
    alignItems: 'baseline',
  },
  '& .MuiBreadcrumbs-separator': {
    marginInline: theme.spacing(0.5),
  },
}));

const Breadcrumbs = ({breadcrumbs = []}) => {
  if (!breadcrumbs || breadcrumbs.length === 0) {
    return null;
  }

  return (
    <StyledBreadcrumbs aria-label="breadcrumb">
      {breadcrumbs.map(({url, label}) => (
        <Crumb url={url} key={url ?? label}>
          {label}
        </Crumb>
      ))}
    </StyledBreadcrumbs>
  );
};

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.array,
};

export default Breadcrumbs;
